import {cloneFromTemplate} from "../admin/images/functions";
import {triggerSelectOptionTab} from "../web/v2/movie_details";
import Episode from "./Episode";
import {customSelectInit, selectOption} from "../custom_select/script";


export default class Season {

    constructor( content_object ) {
        this.content_object = content_object;
        this.template = cloneFromTemplate('#subseries_episode_container');
    }

    element() {
        let seasons_container = this.template.querySelector( '.season-container' );
        let seasons_select = this.template.querySelector( '.tab-pane-seasons' );
        if ( seasons_select ) {
            seasons_select.addEventListener("change", (e) => {
                triggerSelectOptionTab( seasons_select );
            });
        }

        let seasons_content = this.template.querySelector( '.tab-content-seasons' );

        for ( let i in this.content_object.seasons() ) {
            let season = this.content_object.seasons()[i];
            if ( season ) {
                if ( seasons_select ) {
                    let option = this.seasonOption( season );
                    seasons_select.appendChild( option );
                }

                if ( seasons_content ) {
                    let season_container = this.seasonContainer( season );
                    if ( season_container ) {
                        seasons_content.appendChild( season_container );
                    }
                }
            }
        }

        this.seasonsCustomSelect( seasons_container, seasons_select );

        return seasons_container;
    }

    seasonsCustomSelect( container, select ) {
        let custom_select = container.querySelector( '.custom-select-lsi' );
        if ( custom_select ) {
            let custom_select_containers = customSelectInit( [ custom_select ] );
            let current_season = this.content_object.episode.seasonNumber();
            if ( current_season && custom_select_containers[0] ) {
                selectOption( custom_select_containers[0], current_season );
                triggerSelectOptionTab( select );
            }

            let only_one_season = this.content_object.onlyOneSeason();
            if ( only_one_season ) {
                custom_select.style.display = 'none';
            }
        }
    }

    seasonContainer( season ) {
        let episodes = this.content_object.episodes()[season];
        if (episodes && episodes.length > 0) {
            episodes = episodes.sort((a,b) => a['episode_number'] - b['episode_number']);
            let episode_container = this.episodeContainer()

            for (let i in episodes) {
                let episode = new Episode( episodes[i], this.content_object.constants );
                episode_container.appendChild(episode.element());
            }

            let season_tab_pane = this.seasonTabPane(season);
            let title_container = this.seasonTitleContainer( season );
            season_tab_pane.appendChild( title_container );

            season_tab_pane.appendChild(episode_container);

            return season_tab_pane;
        }

        return null;
    }

    seasonTitleContainer( season ) {
        let title_container = document.createElement('div');
        title_container.classList.add('row-fluid');
        title_container.classList.add('text-center');
        title_container.classList.add('w-100');
        title_container.classList.add('season-title');
        title_container.classList.add('pb-2');
        title_container.classList.add('pt-4');
        title_container.innerHTML = this.seasonTitle( season );

        return title_container;
    }

    episodeContainer() {
        let episode_container = document.createElement('div');
        episode_container.classList.add('row');
        episode_container.classList.add('row-cols-1');
        episode_container.classList.add('row-cols-sm-2');
        episode_container.classList.add('row-cols-lg-3');
        episode_container.classList.add('pt-3');
        episode_container.classList.add('season-episode-container');

        return episode_container;
    }

    seasonTabPane( season ) {
        let season_tab_pane = document.createElement('div');
        season_tab_pane.id = this.seasonTargetId( season );
        season_tab_pane.classList.add('tab-pane');
        season_tab_pane.classList.add('tab-pane-toggleable');
        season_tab_pane.classList.add('p-0');
        season_tab_pane.classList.add('m-0');
        if ( this.isActiveSeason( season ) ) {
            season_tab_pane.classList.add('active');
        }

        return season_tab_pane;
    }

    isActiveSeason( season ) {
        return this.content_object.seasons() && season === this.content_object.episode.seasonNumber();
    }

    seasonOption( season ) {
        let season_option = document.createElement('option');
        let target_id = this.seasonTargetId( season );
        season_option.value = season;
        season_option.dataset['target'] = `#${target_id}`;
        season_option.innerHTML = this.seasonTitle( season );

        return season_option;
    }

    seasonTitle( season ) {
        return this.content_object.constants.text.modal.movie_details.tabs.episodes.season + ' ' + season;
    }

    seasonTargetId( season ) {
        return `tab-season${season}`;
    }

}